import script from "./TheHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./TheHeader.vue?vue&type=script&setup=true&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=4cf7342a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf7342a"]])

export default __exports__